import MaskedViewLib from '@react-native-masked-view/masked-view';
import * as React from 'react';
import { ReactNode, useEffect, useRef } from 'react';
import { Platform, View, ViewProps } from 'react-native';

// '-webkit-gradient(linear, left top, left 20%, from(rgba(0,0,0,0)), to(rgba(0,0,0,1)))'

const MaskedView = ({
  webMask,
  maskElement,
  ...props
}: ViewProps & {
  children: ReactNode;
  maskElement: React.ReactElement;
  webMask?: string;
}) => {
  const ref = useRef<MaskedViewLib>(null);
  useEffect(() => {
    if (Platform.OS !== 'web' || ref.current == null || !webMask) {
      return;
    }
    (ref.current as any).style['-webkit-mask-image'] = webMask;
  }, [webMask]);
  if (Platform.OS === 'web') {
    return <View ref={ref} {...props} />;
  }
  return <MaskedViewLib ref={ref} maskElement={maskElement} {...props} />;
};

export default MaskedView;
